<div id="dept-punjabi" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Punjabi</h2>
    <p class="inner-lead mt-3">
      The Department of Punjabi at Shah Satnam Ji Girls' College, Sirsa preserves and promotes Punjabi language, literature and culture. The department provides students with a deep understanding of Punjabi heritage, poetry and prose.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Punjabi as a subject in BA, B.Com, BBA, BAJMC</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Tajinder Kaur</td><td>M.A, M.Ed, M.Sc</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <ul class="inner-lead">
      <li>Gandhi Jayanti Celebration</li>
      <li>Lohri Festival Events</li>
      <li>World Poetry Day Celebration</li>
    </ul>

  </div>
</div>
